import React from 'react';
import IconClose from '../../assets/icons/IconClose';
import IconInformationRed from '../../assets/icons/IconInformationRed';
import IconShop from '../../assets/icons/IconShop';
import { LoanData } from '../../interfaces/Debt';
import {
  TextBold,
  TextMedium,
  TextRegular,
} from '../../styles/GlobalStyledComponents';
import {
  DataReferenceWrapper,
  DataTitle,
  DataWrapper,
  IconCloseWrapper,
  ModalBody,
  ModalContainer,
  ModalHeader,
  TotalAmountWrapper,
  WarningWrapper,
} from './PaymentModalStyledComponents';
import IconBank from '../../assets/icons/IconBank';

interface PaymentModalProps {
  close: () => void;
  loan: LoanData | undefined;
  amount: string | undefined;
}

export const PaymentModal: React.FC<PaymentModalProps> = ({
  close,
  loan,
  amount,
}) => {
  return (
    <ModalContainer id="other-payment-modal">
      <ModalHeader id="other-payment-header">
        <TextBold fontSize={20} lineHeight={32}>
          OPCIONES DE PAGO
        </TextBold>
        <IconCloseWrapper onClick={() => close()} id="other-payment-close-btn">
          <IconClose />
        </IconCloseWrapper>
      </ModalHeader>
      <ModalBody id="other-payment-body">
        <TotalAmountWrapper id="other-payment-total-amount">
          <TextMedium fontSize={16} lineHeight={24}>
            Importe total del pago
          </TextMedium>
          <TextBold fontSize={16} lineHeight={24}>
            {amount}{' '}
            <TextRegular fontSize={12} lineHeight={24}>
              €
            </TextRegular>
          </TextBold>
        </TotalAmountWrapper>
        <TextRegular fontSize={16} color={'gray6'} lineHeight={24}>
          Puedes realizar el pago mediante los siguientes métodos y datos
          descritos a continuación:
        </TextRegular>
        <DataWrapper id="other-payment-data">
          <DataTitle id="other-payment-title">
            <IconShop />
            <TextBold fontSize={16}>Oficina de correos</TextBold>
          </DataTitle>
          <TextRegular fontSize={14} color={'gray6'} lineHeight={22}>
            Número de referencia para el pago:
          </TextRegular>
          <DataReferenceWrapper id="other-payment-reference">
            <TextBold fontSize={16}>{loan?.loan_reference}</TextBold>
            <WarningWrapper id="other-payment-warning">
              <IconInformationRed />
              <TextRegular fontSize={14} color="red4">
                Este número es obligatorio
              </TextRegular>
            </WarningWrapper>
          </DataReferenceWrapper>
          <TextBold fontSize={14}>
            *El DNI del titular de los créditos es obligatorio.
          </TextBold>
        </DataWrapper>
        <DataWrapper id="other-payment-data-2">
          <DataTitle id="other-payment-title-2">
            <IconBank />
            <TextBold fontSize={16}>
              Sucursal bancaria/transferencia bancaria
            </TextBold>
          </DataTitle>
          <TextRegular fontSize={14} color={'gray6'} lineHeight={22}>
            Número de referencia para el pago:
          </TextRegular>
          <DataReferenceWrapper id="other-payment-reference-2">
            <TextBold fontSize={16}>{loan?.loan_reference}</TextBold>
            <WarningWrapper id="other-payment-warning-2">
              <IconInformationRed />
              <TextRegular fontSize={14} color="red4">
                Este número es obligatorio
              </TextRegular>
            </WarningWrapper>
          </DataReferenceWrapper>
          <TextRegular fontSize={14} color={'gray6'} lineHeight={22}>
            Número de cuenta para la transferencia:
          </TextRegular>
          <DataReferenceWrapper id="other-payment-account">
            <TextBold fontSize={16}>{loan?.collecting_account}</TextBold>
          </DataReferenceWrapper>
          <TextBold fontSize={14}>
            *El DNI del titular de los créditos es obligatorio.
          </TextBold>
        </DataWrapper>
      </ModalBody>
    </ModalContainer>
  );
};
